module.exports = __webpack_public_path__ + "img/vip_bg.c89b5744.png";